var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ArrayUtils from '../collections/ArrayUtils';
import Collection from '../collections/Collection';
import Enumerable from '../collections/Enumerable';
Object.defineProperty(Array.prototype, 'after', {
    value: function (predicate) {
        return new Enumerable(this).after(predicate);
    }
});
Object.defineProperty(Array.prototype, 'afterInclude', {
    value: function (predicate) {
        return new Enumerable(this).afterInclude(predicate);
    }
});
Object.defineProperty(Array.prototype, 'aggregate', {
    value: function (seed, func) {
        return new Enumerable(this).aggregate(seed, func);
    }
});
Object.defineProperty(Array.prototype, 'all', {
    value: function (predicate) {
        return new Enumerable(this).all(predicate);
    }
});
Object.defineProperty(Array.prototype, 'any', {
    value: function (predicate) {
        return new Enumerable(this).any(predicate);
    }
});
Object.defineProperty(Array.prototype, 'append', {
    value: function (value) {
        return new Enumerable(this).append(value);
    }
});
Object.defineProperty(Array.prototype, 'as', {
    value: function () {
        return new Enumerable(this).as();
    }
});
Object.defineProperty(Array.prototype, 'atOffsetOfFirst', {
    value: function (predicate, offset) {
        return new Collection(this).atOffsetOfFirst(predicate, offset);
    }
});
Object.defineProperty(Array.prototype, 'average', {
    value: function (selector, valueIfNaN) {
        return new Enumerable(this).average(selector, valueIfNaN);
    }
});
Object.defineProperty(Array.prototype, 'batch', {
    value: function (size) {
        return new Enumerable(this).batch(size);
    }
});
Object.defineProperty(Array.prototype, 'before', {
    value: function (predicate) {
        return new Enumerable(this).before(predicate);
    }
});
Object.defineProperty(Array.prototype, 'beforeInclude', {
    value: function (predicate) {
        return new Enumerable(this).beforeInclude(predicate);
    }
});
Object.defineProperty(Array.prototype, 'clone', {
    value: function (startIndex, endIndexExclusive) {
        return new Collection(this).clone(startIndex, endIndexExclusive);
    }
});
Object.defineProperty(Array.prototype, 'combinationsWith', {
    value: function (other) {
        return new Enumerable(this).combinationsWith(other);
    }
});
Object.defineProperty(Array.prototype, 'contains', {
    value: function (value, equalityComparer) {
        return new Enumerable(this).contains(value, equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'count', {
    value: function (predicate) {
        if (predicate === undefined) {
            return this.length;
        }
        return new Enumerable(this).count(predicate);
    }
});
Object.defineProperty(Array.prototype, 'dimensionCount', {
    value: function () {
        return new Collection(this).dimensionCount();
    }
});
Object.defineProperty(Array.prototype, 'distinct', {
    value: function (equalityComparer) {
        return new Enumerable(this).distinct(equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'distinctConsecutives', {
    value: function (equalityComparer, keepLast) {
        return new Enumerable(this).distinctConsecutives(equalityComparer, keepLast);
    }
});
Object.defineProperty(Array.prototype, 'do', {
    value: function (action) {
        return new Enumerable(this).do(action);
    }
});
Object.defineProperty(Array.prototype, 'evenItems', {
    value: function () {
        return new Enumerable(this).evenItems();
    }
});
Object.defineProperty(Array.prototype, 'except', {
    value: function (other, equalityComparer) {
        return new Enumerable(this).except(other, equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'exists', {
    value: function (predicate) {
        return new Enumerable(this).exists(predicate);
    }
});
Object.defineProperty(Array.prototype, 'first', {
    value: function (predicate) {
        return new Enumerable(this).first(predicate);
    }
});
Object.defineProperty(Array.prototype, 'firstOrDefault', {
    value: function (predicate, defaultValue) {
        return new Enumerable(this).firstOrDefault(predicate);
    }
});
Object.defineProperty(Array.prototype, 'firstIndex', {
    value: function (predicate, start = 0) {
        return new Collection(this).firstIndex(predicate, start);
    }
});
Object.defineProperty(Array.prototype, 'flatten', {
    value: function () {
        return new Collection(this).flatten();
    }
});
Object.defineProperty(Array.prototype, 'get', {
    value: function (index) {
        return new Collection(this).get(index);
    }
});
Object.defineProperty(Array.prototype, 'getFromEnd', {
    value: function (reverseIndex) {
        return new Collection(this).getFromEnd(reverseIndex);
    }
});
Object.defineProperty(Array.prototype, 'getOrDefault', {
    value: function (index, defaultValue) {
        return new Collection(this).getOrDefault(index, defaultValue);
    }
});
Object.defineProperty(Array.prototype, 'getWithinRange', {
    value: function (index, startIndex = 0, endIndexExclusive) {
        return new Collection(this).getWithinRange(index, startIndex, endIndexExclusive);
    }
});
Object.defineProperty(Array.prototype, 'groupBy', {
    value: function (keySelector, elementSelector, resultSelector) {
        return new Enumerable(this).groupBy(keySelector, elementSelector, resultSelector);
    }
});
Object.defineProperty(Array.prototype, 'groupByAsMap', {
    value: function (keySelector, elementSelector, resultSelector) {
        return new Enumerable(this).groupByAsMap(keySelector, elementSelector, resultSelector);
    }
});
Object.defineProperty(Array.prototype, 'hasOneOf', {
    value: function (values) {
        return new Enumerable(this).hasOneOf(values);
    }
});
Object.defineProperty(Array.prototype, 'insert', {
    value: function (item, index) {
        return new Collection(this).insert(item, index);
    }
});
Object.defineProperty(Array.prototype, 'intersect', {
    value: function (other, equalityComparer) {
        return new Enumerable(this).intersect(other, equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'isEmpty', {
    value: function () {
        return new Collection(this).isEmpty();
    }
});
Object.defineProperty(Array.prototype, 'isIndexInRange', {
    value: function (index) {
        return new Collection(this).isIndexInRange(index);
    }
});
Object.defineProperty(Array.prototype, 'keyBy', {
    value: function (keySelector) {
        return new Enumerable(this).keyBy(keySelector);
    }
});
Object.defineProperty(Array.prototype, 'keyByAsMap', {
    value: function (keySelector) {
        return new Enumerable(this).keyByAsMap(keySelector);
    }
});
Object.defineProperty(Array.prototype, 'last', {
    value: function (predicate) {
        return new Collection(this).last(predicate);
    }
});
Object.defineProperty(Array.prototype, 'lastIndex', {
    value: function (predicate, start) {
        return new Collection(this).lastIndex(predicate, start);
    }
});
Object.defineProperty(Array.prototype, 'lastOrDefault', {
    value: function (predicate, defaultValue) {
        return new Collection(this).lastOrDefault(predicate, defaultValue);
    }
});
Object.defineProperty(Array.prototype, 'max', {
    value: function (selector) {
        return new Enumerable(this).max(selector);
    }
});
Object.defineProperty(Array.prototype, 'maxIndex', {
    value: function (selector) {
        return new Collection(this).maxIndex(selector);
    }
});
Object.defineProperty(Array.prototype, 'min', {
    value: function (selector) {
        return new Enumerable(this).min(selector);
    }
});
Object.defineProperty(Array.prototype, 'minIndex', {
    value: function (selector) {
        return new Collection(this).minIndex(selector);
    }
});
Object.defineProperty(Array.prototype, 'move', {
    value: function (sourceIndex, targetIndex) {
        return new Collection(this).move(sourceIndex, targetIndex);
    }
});
Object.defineProperty(Array.prototype, 'moveRange', {
    value: function (startIndex, endIndexExclusive, targetIndex) {
        return new Collection(this).moveRange(startIndex, endIndexExclusive, targetIndex);
    }
});
Object.defineProperty(Array.prototype, 'none', {
    value: function (predicate) {
        return new Enumerable(this).none(predicate);
    }
});
Object.defineProperty(Array.prototype, 'oddItems', {
    value: function () {
        return new Enumerable(this).oddItems();
    }
});
Object.defineProperty(Array.prototype, 'orderBy', {
    value: function (keySelector, comparer, order) {
        return new Enumerable(this).orderBy(keySelector, comparer, order);
    }
});
Object.defineProperty(Array.prototype, 'orderByDescending', {
    value: function (keySelector, comparer) {
        return new Enumerable(this).orderByDescending(keySelector, comparer);
    }
});
Object.defineProperty(Array.prototype, 'orderByLike', {
    value: function (keySelector, order, equalityComparer) {
        return new Enumerable(this).orderByLike(keySelector, order, equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'pushIfAbsent', {
    value: function (value) {
        return new Collection(this).pushIfAbsent(value);
    }
});
Object.defineProperty(Array.prototype, 'pushMany', {
    value: function (values) {
        return new Collection(this).pushMany(values);
    }
});
Object.defineProperty(Array.prototype, 'remove', {
    value: function (item) {
        return new Collection(this).remove(item);
    }
});
Object.defineProperty(Array.prototype, 'removeAt', {
    value: function (index, count = 1) {
        return new Collection(this).removeAt(index, count);
    }
});
Object.defineProperty(Array.prototype, 'removeRange', {
    value: function (startIndex, endIndexExclusive) {
        return new Collection(this).removeRange(startIndex, endIndexExclusive);
    }
});
Object.defineProperty(Array.prototype, 'removeWhere', {
    value: function (predicate) {
        return new Collection(this).removeWhere(predicate);
    }
});
Object.defineProperty(Array.prototype, 'reversed', {
    value: function () {
        return new Collection(this).reversed();
    }
});
Object.defineProperty(Array.prototype, 'select', {
    value: function (selector) {
        return new Enumerable(this).select(selector);
    }
});
Object.defineProperty(Array.prototype, 'selectMany', {
    value: function (selector) {
        return new Enumerable(this).selectMany(selector);
    }
});
Object.defineProperty(Array.prototype, 'sequenceEqual', {
    value: function (other, equalityComparer) {
        return new Enumerable(this).sequenceEqual(other, equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'single', {
    value: function (predicate) {
        return new Enumerable(this).single(predicate);
    }
});
Object.defineProperty(Array.prototype, 'singleOrDefault', {
    value: function (predicate, defaultValue) {
        return new Enumerable(this).singleOrDefault(predicate, defaultValue);
    }
});
Object.defineProperty(Array.prototype, 'skip', {
    value: function (count) {
        return new Enumerable(this).skip(count);
    }
});
Object.defineProperty(Array.prototype, 'sorted', {
    value: function (order, comparer) {
        return new Enumerable(this).sorted(order, comparer);
    }
});
Object.defineProperty(Array.prototype, 'sortedLike', {
    value: function (order, equalityComparer) {
        return new Enumerable(this).sortedLike(order, equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'sum', {
    value: function (selector, valueIfNaN) {
        return new Enumerable(this).sum(selector, valueIfNaN);
    }
});
Object.defineProperty(Array.prototype, 'swap', {
    value: function (index1, index2) {
        return new Collection(this).swap(index1, index2);
    }
});
Object.defineProperty(Array.prototype, 'take', {
    value: function (count) {
        return new Enumerable(this).take(count);
    }
});
Object.defineProperty(Array.prototype, 'toArray', {
    value: function () {
        return this;
    }
});
Object.defineProperty(Array.prototype, 'toDictionary', {
    value: function (keySelector, valueSelector) {
        return new Enumerable(this).toDictionary(keySelector, valueSelector);
    }
});
Object.defineProperty(Array.prototype, 'toCollection', {
    value: function () {
        return new Collection(this);
    }
});
Object.defineProperty(Array.prototype, 'toEnumerable', {
    value: function () {
        return new Enumerable(this);
    }
});
Object.defineProperty(Array.prototype, 'toMap', {
    value: function (keySelector, valueSelector) {
        return new Enumerable(this).toMap(keySelector, valueSelector);
    }
});
Object.defineProperty(Array.prototype, 'union', {
    value: function (other, equalityComparer) {
        return new Enumerable(this).union(other, equalityComparer);
    }
});
Object.defineProperty(Array.prototype, 'when', {
    value: function (condition, then) {
        return new Enumerable(this).when(condition, then);
    }
});
Object.defineProperty(Array.prototype, 'where', {
    value: function (predicate) {
        return new Enumerable(this).where(predicate);
    }
});
Object.defineProperty(Array.prototype, 'whereAnd', {
    value: function (...predicates) {
        return new Enumerable(this).whereAnd(...predicates);
    }
});
Object.defineProperty(Array.prototype, 'whereIn', {
    value: function (selector, values) {
        return new Enumerable(this).whereIn(selector, values);
    }
});
Object.defineProperty(Array.prototype, 'whereNotIn', {
    value: function (selector, values) {
        return new Enumerable(this).whereNotIn(selector, values);
    }
});
Object.defineProperty(Array.prototype, 'whereNotNull', {
    value: function (predicate) {
        return new Enumerable(this).whereNotNull(predicate);
    }
});
Object.defineProperty(Array.prototype, 'whereNull', {
    value: function (predicate) {
        return new Enumerable(this).whereNull(predicate);
    }
});
Object.defineProperty(Array.prototype, 'whereOr', {
    value: function (...predicates) {
        return new Enumerable(this).whereOr(...predicates);
    }
});
Object.defineProperty(Array.prototype, 'whereStringEquals', {
    value: function (value1Selector, value2Selector, caseSensitive) {
        return new Enumerable(this).whereStringEquals(value1Selector, value2Selector, caseSensitive);
    }
});
Array.compare = function (array1, array2) {
    return ArrayUtils.compare(array1, array2);
};
Array.fromAsyncIterable = function (iterable) {
    return __awaiter(this, void 0, void 0, function* () {
        return ArrayUtils.fromAsyncIterable(iterable);
    });
};
Array.fromValue = function (value, length) {
    return ArrayUtils.fromValue(value, length);
};
Array.fromRange = function (start, end, step = 1) {
    return ArrayUtils.fromRange(start, end, step);
};
Array.isNullOrEmpty = function (obj) {
    return ArrayUtils.isNullOrEmpty(obj);
};
//# sourceMappingURL=ArrayExtensions.js.map